import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import config from './modules/config';
import pedidos from './modules/pedidos';
import perfil from './modules/perfil';
import resumen from './modules/resumen';
import granos from './modules/granos';
import expand from './modules/expand';
import posiciones from './modules/posiciones';
import contratos from './modules/contratos';
import cfiscales from './modules/cfiscales';
import autorizacion from './modules/autorizacion';
import dashboard from './modules/dashboard';
import recibos from './modules/recibos';
import usuarios from './modules/usuarios';
import ordenescompra from './modules/ordenescompra';

Vue.use(Vuex, axios);

export default new Vuex.Store({
	modules: {
		config,
		perfil,
		pedidos,
		resumen,
		granos,
		expand,
		posiciones,
		contratos,
		cfiscales,
		dashboard,
		recibos,
		usuarios,
		ordenescompra,
		autorizacion,
	},
});
